module.exports = __webpack_public_path__ + "static/simple-line-67ae4033ae14d335853fec37dc7d9952.png";